import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AdminOrdersService } from 'src/app/features/orders/services/orders/admin-orders.service';
import { QoudsUtilService } from 'src/app/features/orders/services/utils/qouds-util/qouds-util.service';
import { OrderState } from 'src/app/features/orders/state/order.state';
import { UserType } from 'src/app/models/enums/user-type.enum';
import { UserRoles } from 'src/app/models/enums/user-roles.enum';
import { Order } from 'src/app/models/interfaces/order';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { UserService } from 'src/app/core/services/user/user.service';

@Component({
    selector: 'app-financial-info',
    templateUrl: './financial-info.component.html',
    styleUrls: ['./financial-info.component.scss'],
    standalone: false
})
export class FinancialInfoComponent {
  roles: any[];
  userRoles = UserRoles;
  orders: Order;
  flag: boolean = false;
  userType = UserType;
  received = {
    is_received: true,
  };
  orderDetails$: Observable<any>;
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  successImg: boolean = true;
  confirmMsg = 'تم الإضافة بنجاح';

  constructor(
    private order: AdminOrdersService,
    private dialog: MatDialog,
    private qoudsUtil: QoudsUtilService,
    private userService: UserService,
    private store: Store) {
    this.orderDetails$ = this.store.select(OrderState.getOrderDetails);
  }

  ngOnInit(): void {
    let groups = this.userService.userGroups;
    this.roles = groups.map((group) => group.identifier);
    this.orderDetails$.subscribe((data) => {
      this.orders = data;
    });
  }

  updateQouds(orderId) {
   this.qoudsUtil.updateQouds(this, orderId);
  }

  createQoyoodInvoice(orderId) {
    this.qoudsUtil.createQoyoodInvoice(this, orderId);
  }

  deliveredOrder(id, received) {
    this.flag = true;
    this.order.changePaymentStatus(id, received).subscribe(
      (data) => {
        this.orders.payment_data.payment_status = 'مستلم';
      },
      (error) => {
        try {
          console.log(error);
        } catch {
          console.log(error);
        }
      }
    );
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
        data: {
          imgSuccess: this.successImg,
          message: this.confirmMsg,
          button: 'تم',
        },
    });
  }
}
